import headphones from '../components/assets/shared/desktop/image-headphones.png';
import earphones from '../components/assets/shared/desktop/image-earphones.png';
import speakers from '../components/assets/shared/desktop/image-speakers.png';

export const links = [
  {
    id: 1,
    text: 'home',
    url: '/',
  },
  {
    id: 2,
    text: 'headphones',
    url: '/headphones',
  },
  {
    id: 3,
    text: 'speakers',
    url: '/speakers',
  },
  {
    id: 4,
    text: 'earphones',
    url: '/earphones',
  },
];

export const categories = [
  {
    id: 1,
    img: headphones,
    text: 'headphones',
    url: '/headphones',
  },
  {
    id: 2,
    img: speakers,
    text: 'speakers',
    url: '/speakers',
  },
  {
    id: 3,
    img: earphones,
    text: 'earphones',
    url: '/earphones',
  },
];